import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';

import { HomeProject } from '@models/swagger';
import { ApiService, DefaultHttpHeaders } from '@services/api/api.service';

export interface PutProjectParams extends DefaultHttpHeaders {
  projectQuoteId: string;
}

@Injectable()
export class PutProjectService extends ApiService {
  constructor(protected readonly injector: Injector) {
    super(injector);
  }

  /**
   * Updates insurance project
   * Updates insurance project
   * https://d2go64w4712gob.cloudfront.net/swagger/apis_trasversales/italia/api_Verti.html#/Project/putProject
   */
  putProject(body: HomeProject, params: PutProjectParams): Observable<HomeProject> {
    const pathParams = {
      projectQuoteId: params.projectQuoteId,
    };
    return this.put<HomeProject, HomeProject>({
      suffix: `/home/project/${pathParams.projectQuoteId}`,
      body,
      authenticationType: 'jwt',
    });
  }
}
